export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "拾真社的爆料是从哪里来的？",
    a: "来源主要分三类：当事人或内部人员提供的原始材料、公开可查的官方记录，以及读者投稿线索。每一条材料进入档案前，都会先做来源登记，再进入求证流程。",
  },
  {
    q: "可信度评分是怎么算出来的？",
    a: "评分由来源数量、材料类型、可复核程度、是否存在相互矛盾四项加权得出。原始材料越多样、越能交叉印证，评分越高；仅凭单一截图或口述的档案，评分会被明显压低。",
  },
  {
    q: "为什么有的档案显示「部分属实」？",
    a: "很多爆料并非全真或全假。常见情况是核心事实成立，但流传版本存在夸大、拼接或时间错位。这种情况下我们会给出「部分属实」，并逐条说明哪一部分成立、哪一部分不成立。",
  },
  {
    q: "档案会更新吗？",
    a: "会。标注为「持续跟进」的档案会随新证据更新，页面顶部会显示最近更新时间。已经得出明确结论的档案，如出现新证据也会重新开档核实。",
  },
  {
    q: "我可以提供线索或指出错误吗？",
    a: "非常欢迎。你可以在「联系我们」页面提交线索、原始材料或纠错说明。涉及隐私的材料我们会做脱敏处理，并对投稿人身份保密。",
  },
  {
    q: "为什么有些内容不给结论？",
    a: "当关键来源无法取得、或材料之间存在无法解释的矛盾时，我们会明确写「待求证」而不是勉强下结论。给出一个错误结论，比暂时没有结论的代价更大。",
  },
];